import {
    AISharedReferenceType,
    AISharedSmartAction,
    AISharedSmartActionId,
} from '../models/ai-shared.model';

const POST_SUMMARY: AISharedSmartAction = {
    id: AISharedSmartActionId.POST_SUMMARY,
    label: 'AI.SMART_ACTION.POST_SUMMARY.LABEL',
    message: 'AI.SMART_ACTION.POST_SUMMARY.MESSAGE',
    icon: 'short-text',
};

const POST_COMMENTS_SUMMARY: AISharedSmartAction = {
    id: AISharedSmartActionId.POST_COMMENTS_SUMMARY,
    label: 'AI.SMART_ACTION.POST_COMMENTS_SUMMARY.LABEL',
    message: 'AI.SMART_ACTION.POST_COMMENTS_SUMMARY.MESSAGE',
    icon: 'comments',
};

export const AI_SHARED_SMART_ACTIONS: Record<
    AISharedReferenceType,
    AISharedSmartAction[]
> = {
    [AISharedReferenceType.POST]: [POST_SUMMARY, POST_COMMENTS_SUMMARY],
    [AISharedReferenceType.ATTACHMENT]: [
        {
            id: AISharedSmartActionId.ATTACHMENT_SUMMARY,
            label: 'AI.SMART_ACTION.ATTACHMENT_SUMMARY.LABEL',
            message: 'AI.SMART_ACTION.ATTACHMENT_SUMMARY.MESSAGE',
            icon: 'short-text',
        },
    ],
    [AISharedReferenceType.COMMENT]: [
        {
            id: AISharedSmartActionId.COMMENT_COMMENTS_SUMMARY,
            label: 'AI.SMART_ACTION.COMMENT_POST_COMMENTS_SUMMARY.LABEL',
            message: 'AI.SMART_ACTION.COMMENT_POST_COMMENTS_SUMMARY.MESSAGE',
            icon: 'comments',
        },
    ],
};
